import request from '../request'
import { conversionData, decodeExtraFieldsKeys } from './utils'
import { storage } from '../utils'
import { cloneDeep } from 'lodash';
import './styles.scss'

export const getB3OrderExtras = () => {
  let B3OrderExtras = storage.B3OrderExtras.getValue()
  B3OrderExtras = B3OrderExtras ? JSON.parse(B3OrderExtras) : []
  return B3OrderExtras
}

export const getDefaultB3OrderExtrasVal = () => {
  const B3OrderExtras = getB3OrderExtras()
  if (B3OrderExtras.length) {
    const customFields: any = {}
    B3OrderExtras.forEach((item: any) => {
      customFields[item.name] = item?.val || ''
    })
    return customFields
  }
  return ''
}

export const getB3OrderFiles = async () => {

  const { list }: any = await request.api.getExtraFieldsModule('order')

  if (list && list.length) {
    const orderConversion = conversionData(list, true)

    const orderFields = cloneDeep(orderConversion)

    storage.B3OrderExtras.setValue(JSON.stringify(orderFields))
  }
}


export const saveOrderExtraVlaues = (values: any) => {
  const orderExtras = getB3OrderExtras()
  if (orderExtras.length > 0) {
    let getOrderVal: any = {}
    orderExtras.map((item: any) => {
      if (!item.visibleToEnduser) {
        getOrderVal[item.name] = ''
      }
    })
    if ((values as any)?.customFields) {
      getOrderVal = { ...(values as any)?.customFields, ...getOrderVal }
    }
    localStorage.setItem('B3PaymentCustomFields', JSON.stringify(getOrderVal))
  }
}

export const validateOrderExtraFields = async (values: any) => {
  if ((values as any)?.customFields && JSON.stringify((values as any)?.customFields) !== '{}') {
    const { customFields }: any = values
    const decodeExtraField = decodeExtraFieldsKeys(customFields)
    const validateCustomField = Object.keys(decodeExtraField).map((item: any) => {
      return {
        fieldName: item,
        fieldValue: decodeExtraField[item]
      }
    })
    await await request.api.validateExtraFieldsModule('order', {
      extraFields: validateCustomField
    })
  }
}
